import React from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { sisccTheme } from '@sis-cc/dotstatsuite-visions';
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles';
import { getIsRtl, getHasAccessibility } from '../selectors/router';
import { Rtl } from './jss-provider';

const excel = {
  headerFont: '#ffffff',
  sectionFont: '#000000',
  rowFont: '#000000',
};

const Provider = ({ theme, children }) => {
  const isRtl = useSelector(getIsRtl);
  const isA11y = useSelector(getHasAccessibility);

  const muiTheme = R.pipe(
    R.flip(R.mergeDeepRight)(theme),
    R.assocPath(['mixins', 'excel'], excel),
    createTheme,
  )(
    sisccTheme({
      rtl: isRtl ? 'rtl' : 'ltr',
      isA11y,
      outerPalette: theme.outerPalette,
    }),
  );

  return (
    <Rtl>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
      </StyledEngineProvider>
    </Rtl>
  );
};

export default Provider;
